import { COMMERCE_HUB_EARLY_ADOPTER_PROMOTION_KEYS } from 'pricing-pages-ui-components/constants/PromotionKeys';
import { NavItemEnum } from '../../../constants/routing/NavItems';
import { usePurchaseableProductsForTerm } from '../../../hooks/useBulkPurchaseOptions';
import { useCurrentNavItem } from '../../../hooks/useCurrentNavItem';
import { useDisplayedCurrencyCode } from '../pricing/useCurrencyDetails';
const PROFESSIONAL_API_NAME = 'commerce-hub-professional';
const ENTERPRISE_API_NAME = 'commerce-hub-enterprise';
export const useCommerceHubEarlyAdopterBanner = () => {
  var _professionalAnnualPu, _enterpriseAnnualPurc;
  const currentNavItem = useCurrentNavItem();
  const isCommerceRoute = currentNavItem === NavItemEnum.COMMERCE;
  const {
    purchaseOptionsForTerm: professionalAnnualPurchaseOption,
    loading: professionalLoading,
    error: professionalError
  } = usePurchaseableProductsForTerm({
    apiName: PROFESSIONAL_API_NAME,
    queryParamTerm: 'annual'
  });
  const {
    purchaseOptionsForTerm: enterpriseAnnualPurchaseOption,
    loading: enterpriseLoading,
    error: enterpriseError
  } = usePurchaseableProductsForTerm({
    apiName: ENTERPRISE_API_NAME,
    queryParamTerm: 'annual'
  });
  const displayedCurrencyCode = useDisplayedCurrencyCode();
  const isEligibleForPromotion = (professionalAnnualPurchaseOption === null || professionalAnnualPurchaseOption === void 0 || (_professionalAnnualPu = professionalAnnualPurchaseOption.discounts) === null || _professionalAnnualPu === void 0 ? void 0 : _professionalAnnualPu.some(discount => COMMERCE_HUB_EARLY_ADOPTER_PROMOTION_KEYS.includes(discount.promotionId))) && (enterpriseAnnualPurchaseOption === null || enterpriseAnnualPurchaseOption === void 0 || (_enterpriseAnnualPurc = enterpriseAnnualPurchaseOption.discounts) === null || _enterpriseAnnualPurc === void 0 ? void 0 : _enterpriseAnnualPurc.some(discount => COMMERCE_HUB_EARLY_ADOPTER_PROMOTION_KEYS.includes(discount.promotionId)));
  const professionalAnnualPrice = professionalAnnualPurchaseOption === null || professionalAnnualPurchaseOption === void 0 ? void 0 : professionalAnnualPurchaseOption.monthly.calculatedPrice;
  const enterpriseAnnualPrice = enterpriseAnnualPurchaseOption === null || enterpriseAnnualPurchaseOption === void 0 ? void 0 : enterpriseAnnualPurchaseOption.monthly.calculatedPrice;
  const professionalNonDiscountedPrice = professionalAnnualPurchaseOption === null || professionalAnnualPurchaseOption === void 0 ? void 0 : professionalAnnualPurchaseOption.monthly.fullPrice;
  const enterpriseNonDiscountedPrice = enterpriseAnnualPurchaseOption === null || enterpriseAnnualPurchaseOption === void 0 ? void 0 : enterpriseAnnualPurchaseOption.monthly.fullPrice;
  const loading = professionalLoading || enterpriseLoading;
  const error = professionalError || enterpriseError;
  const shouldShowBanner = Boolean(isCommerceRoute && !loading && !error && isEligibleForPromotion && professionalAnnualPrice && enterpriseAnnualPrice && professionalNonDiscountedPrice && enterpriseNonDiscountedPrice);
  return {
    shouldShowBanner,
    professionalPrice: professionalAnnualPrice,
    enterprisePrice: enterpriseAnnualPrice,
    professionalNonDiscountedPrice,
    enterpriseNonDiscountedPrice,
    currencyCode: displayedCurrencyCode,
    loading,
    error
  };
};